/**
 * React Query hook for dashboard chart series.
 */

import { useQuery } from '@tanstack/react-query';
import { getDashboardCharts } from '@/services/dashboard.service';
import type { DashboardStatsQuery } from '@/types/dashboard.types';

/** `GET /dashboard/charts` query. */
export const useDashboardCharts = (query?: DashboardStatsQuery) => {
  return useQuery({
    queryKey: ['dashboardCharts', query],
    queryFn: () => getDashboardCharts(query),
    refetchOnWindowFocus: true,
    refetchInterval: 30_000,
  });
};
